"use strict";

(function () {

    function enablePopup() {
        let redirectionPopup = document.querySelector('#redirection-popup');
        if (!redirectionPopup.classList.contains('active'))
            redirectionPopup.classList.add('active');
    }

    function disablePopup() {
        let redirectionPopup = document.querySelector('#redirection-popup');
        if (redirectionPopup.classList.contains('active'))
            redirectionPopup.classList.remove('active');
    }

    function cancelBtnClicked(event) {
        event.preventDefault();
        disablePopup();
    }
  
    function isBlipsUrl(url) {
        let isLocalHost = false;
        let isBlips = false;

        //searches string with case insensitivity
        let index = url.search(/Blips.fm/i);
        let result = url.substr(index, 8);
        if (result === 'blips.fm')
            isBlips = true;

        if (url.search(/localhost:/i) !== -1)
            isLocalHost = true;

        if (isLocalHost || isBlips)
            return true;

        return false;
    }

    function onLinkClick(event) {
        event.preventDefault();
        let proceedBtn = document.querySelector('#rp-proceed');
        proceedBtn.href = event.target.href;
        proceedBtn.target = '_blank';

        if (isBlipsUrl(event.target.href)) {
            proceedBtn.target = '_self';
            proceedBtn.click();
        }
        else {
            let cancelBtn = document.querySelector('#rp-cancel');
            proceedBtn.addEventListener('click', () => disablePopup());
            cancelBtn.addEventListener('click', cancelBtnClicked);
            enablePopup();
        }
    }

    function setEvents(foundLinks) {
        foundLinks.forEach(link => {
            link.addEventListener('click', onLinkClick);
        });

        document.body.addEventListener('click', event => {
            if (event.target.tagName.toLowerCase() === 'a')
                return;

            let rp = event.target.closest('#redirection-popup');
            if (rp == null)
                disablePopup();
        });
    }

    let blocks = document.querySelectorAll('.block');
    let foundLinks = [];
    blocks.forEach(block => {
        let links = Array.from(block.getElementsByTagName('a'));
        links.forEach(link => foundLinks.push(link));
    });

    setEvents(foundLinks);

})();